import { render } from "./CollectionDetailPage.vue?vue&type=template&id=0b49a996&scoped=true&ts=true"
import script from "./CollectionDetailPage.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailPage.vue?vue&type=script&lang=ts"

import "./CollectionDetailPage.vue?vue&type=style&index=0&id=0b49a996&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b49a996"]])

export default __exports__